import { useEffect, useState, useCallback } from "react";

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const handleOnline = useCallback(() => setIsOnline(true), []);
  const handleOffline = useCallback(() => setIsOnline(false), []);

  useEffect(() => {
    const controller = new AbortController();

    window.addEventListener("online", handleOnline, {
      signal: controller.signal,
    });
    window.addEventListener("offline", handleOffline, {
      signal: controller.signal,
    });

    return () => {
      controller.abort();
    };
  }, [handleOnline, handleOffline]);

  return isOnline;
}
